import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';


import {  
  mskVisualisationDetails
} from 'Actions';

class postureComponent extends Component {
  static propTypes = {
    classes: PropTypes.object,
  };

  constructor(props) {
    super(props);
  }

  render() {

    const { visualisationdetails, loading} = this.props;
    let posturelist= visualisationdetails.posture; 

    const styles = {
        table: {
            border: "2px solid rgb(0, 0, 0)",
            borderColor:"rgb(0 0 0 / 49%)",
            borderStyle:"solid",
            height : "470px",
            marginTop :"10px",
            color:"#000"
        },
        tabletrtd: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px"
        },
        tabletrtdhead:{
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            fontWeight:"bold",
            textAlign:"center"
        }
    };
    return (
      
         <div className="row">
           <div className="col-md-3">
                <img src={require('Assets/img/tsga2.png')} className="img-fluid" alt="site-logo" style={{height: "470px", marginTop: "10px", marginLeft: "10px"}} />
           </div>
           <div className="col-md-9">
                    <table className="table align-items-center table-flush" style={styles.table}>                        
                        <tbody>
                            <tr>
                                <td style={styles.tabletrtdhead}>REGIONS</td>
                                {posturelist.map((shldval) => (
                                    <td style={styles.tabletrtdhead}>{shldval.assessment}</td>
                                ))}
                            </tr>
                            <tr>
                                <td style={styles.tabletrtdhead}>HEAD</td>
                                {posturelist.map((shldval) => (
                                    <td style={styles.tabletrtd}>{shldval.head}</td>
                                ))}
                            </tr>
                            <tr>
                                <td style={styles.tabletrtdhead}>SHOULDERS</td>
                                {posturelist.map((shldval) => (
                                    <td style={styles.tabletrtd}>{shldval.shoulder}</td>
                                ))}
                            </tr>
                            <tr>
                                <td style={styles.tabletrtdhead}>Tx SPINE</td>
                                {posturelist.map((shldval) => (
                                    <td style={styles.tabletrtd}>{shldval.thoracic}</td>
                                ))}
                            </tr>
                            <tr>
                                <td style={styles.tabletrtdhead}>Lx SPINE</td>
                                {posturelist.map((shldval) => (
                                    <td style={styles.tabletrtd}>{shldval.lumbar}</td>
                                ))}
                            </tr>
                            <tr>
                                <td style={styles.tabletrtdhead}>PELVIS</td>
                                {posturelist.map((shldval) => (
                                    <td style={styles.tabletrtd}>{shldval.pelvis}</td>
                                ))}
                            </tr>
                            <tr>
                                <td style={styles.tabletrtdhead}>KNEE</td>
                                {posturelist.map((shldval) => (
                                    <td style={styles.tabletrtd}>{shldval.knee}</td>
                                ))}
                            </tr>
                            <tr>
                                <td style={styles.tabletrtdhead}>FOOT</td>
                                {posturelist.map((shldval) => (
                                    <td style={styles.tabletrtd}>{shldval.feet}</td>
                                ))}
                            </tr>
                            
                        </tbody>
                    </table>        
           </div>

         </div>
    );
  }
}

const mapStateToProps = ({ mskvisualisation }) => {
  const { visualisationdetails, loading } = mskvisualisation;
return { visualisationdetails, loading };
}

export default connect(mapStateToProps, {
  mskVisualisationDetails
})(postureComponent); 